import React from "react";
import Link from "gatsby-link";
import Nav from "../Nav";

const Header = () => (
	<header className="site-header">
		<div className="logo">
			<Link to="/">Andy Lincoln</Link>
		</div>
		<Nav />
	</header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js